import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function deleteEmailNEO (data = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getNotification)
    })
  } else {
    const req = {
      url: '/api/NEO/eliminaremailneo',
      method: 'DELETE',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data,
      params,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { deleteEmailNEO }
